import { render, staticRenderFns } from "./OperatnLuogoNascitaInfo.vue?vue&type=template&id=f42e8574&"
import script from "./OperatnLuogoNascitaInfo.vue?vue&type=script&lang=ts&"
export * from "./OperatnLuogoNascitaInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports